import { render } from "./imageField.vue?vue&type=template&id=b974db04"
import script from "./imageField.vue?vue&type=script&lang=js"
export * from "./imageField.vue?vue&type=script&lang=js"

import "./imageField.vue?vue&type=style&index=0&id=b974db04&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__